var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('progress-bar',{ref:"progressBar",attrs:{"val":this.$data.data.prosess,"text":this.$data.data.prosess+"%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }